/**
 * Supported stream types by MKPlayer.
 */
export enum MKStreamType {
    /**
     * Apple HLS streams.
     */
    Hls = "hls",

    /**
     * MPEG-DASH streams.
     */
    Dash = "dash",

    /**
     * Progressive MP4 or WebM streams.
     */
    Progressive = "progressive",

    /**
     * Microsoft Smooth Streaming streams.
     */
    Smooth = "smooth",

    /**
     * WebRTC based WHEP stream.
     */
    Whep = "whep",

    /**
     * No stream specified.
     */
    Unknown = "unknown"
}